import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
//import logo from 'assets/img/illustrations/CodersDen5.png';
import SettingsService from 'components/app/directory/SettingsService';
import rebirthLogo from 'assets/img/illustrations/rebirth-logo-wod.png';
const Logo = ({ at, width, className, textClass, ...rest }) => {
  const [logo, setLogo] = React.useState(
    rebirthLogo
  );
  try {
    SettingsService.retrieveSettings().then(setting => {
      if (setting?.logo) {
        const accountLogo = setting.logo;
        console.log('Account Logo:', accountLogo);
        setLogo(accountLogo);
      }
    });
  } catch (error) {
    console.error('Error retrieving settings:', error);
  }

  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img className="me-2" src={logo} alt="Logo" width={width} />
        <span className={classNames('font-sans-serif', textClass)}>WOD</span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
